import { render, staticRenderFns } from "./CommunicationPreferenceSelector.vue?vue&type=template&id=68128353"
import script from "./CommunicationPreferenceSelector.vue?vue&type=script&lang=js"
export * from "./CommunicationPreferenceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports